import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse, JWTError } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type SetUserPasswordResponseType = {};

export type SetUserPasswordParams = {
  password: string;
  token: string;
};

export const useSetUserPassword = (
  options?: MutationOptions<
    SetUserPasswordResponseType,
    SetUserPasswordParams,
    AxiosError<ApiError | JWTError>
  >
) =>
  useMutation({
    mutationFn: async (params) => {
      const { data } = await api.post<ApiResponse<SetUserPasswordResponseType>>(
        '/auth/set-password',
        params
      );

      return data.data;
    },
    ...options,
  });
